import React from "react";
import PropTypes from "prop-types";

export default function CloseSVG({
  className,
  id,
  styles
}) {
  const {
    height,
    width,
    fill
  } = styles;

  return (
    <svg
      id={id}
      className={className}
      width={width || "32px"}
      height={height || "32px"}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon/Action/Close</title>
      <g
        fillRule="evenodd"
        id="Icon/Action/Close"
        strokeWidth="1"
      >
        <polygon
          id="Shape"
          fill={fill || "#677383"}
          points="27.2 1 16 12.2 4.8 1 1 4.8 12.2 16 0 28.2 3.8 32 16 19.8 28.2 32 32 28.2 19.8 16 31 4.8"
        >
        </polygon>
      </g>
    </svg>

  );
}

CloseSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

CloseSVG.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
